<script setup lang="ts">
import merge from 'lodash-es/merge';
import ImagesSlide from './ImageSlide.vue';

defineOptions({
    name: 'WidgetLogoCarouselSettings'
});

const { $t } = useLocalization();

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    description: '',
    images: []
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

const addImage = (): void =>
{
    const ids = form.value.settings.images.map((x: { id: any }) => x.id);

    const maxId = form.value.settings.images.length > 0 ? Math.max(...ids) : 1;

    form.value.settings.images.push({
        id: maxId + 1,
        link: '',
        file: null
    });
};

const removeImage = (index: number): void =>
{
    const items = form.value.settings.images.slice();

    items.splice(index, 1);
    form.value.settings.images = items;
};

const imageUp = (index: number): void =>
{
    if (index > 0)
    {
        const items = form.value.settings.images.splice(index, 1);

        form.value.settings.images.splice(index - 1, 0, items[0]);

        form.value.$errors.clear();
    }
};

const imageDown = (index: number): void =>
{
    if (index < form.value.settings.images.length - 1)
    {
        const items = form.value.settings.images.splice(index, 1);

        form.value.settings.images.splice(index + 1, 0, items[0]);

        form.value.$errors.clear();
    }
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);

    if (!form.value.settings.images.length)
    {
        form.value.settings.images = [{
            id: 1,
            link: '',
            file: null
        }];
    }
});
</script>

<template>
    <div v-for="(image, id) in form.settings.images" :key="image.id" class="widget-logo-carousel">
        <ImagesSlide :id="id" v-model="form" />
        <div class="d-flex widget-logo__delete">
            <div class="input-group-append flex-grow-1 me-2">
                <ActionButton
                    variant="danger"
                    class="w-100"
                    icon="far fa-trash"
                    :text="$t('[[[Usuń obrazek]]]')"
                    :title="$t('[[[Usuń obrazek]]]')"
                    :confirm="$t('[[[Potwierdzenie usunięcia]]]')"
                    :disabled="form.settings.images.length < 2"
                    @click="removeImage(id)"
                />
            </div>
            <ActionButton variant="secondary" icon="far fa-arrow-up" :title="$t('[[[Wyżej]]]') " :disabled="id == 0" @click="imageUp(id)" />
            <ActionButton variant="secondary" icon="far fa-arrow-down" :title="$t('[[[Niżej]]]')" :disabled="id == form.settings.images.length - 1" @click="imageDown(id)" />
        </div>
    </div>
    <div>
        <ActionButton variant="light" class="w-100" icon="far fa-plus" :text="$t('[[[Dodaj obrazek]]]')" @click="addImage()" />
    </div>
    <IdeoFormGroup :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('settings.description')" :state="form.$errors.state('settings.description')">
        <RichTextEditor id="description" v-model="form.settings.description" name="settings.description" />
    </IdeoFormGroup>
</template>

<style lang="scss">
.widget-logo-carousel {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    border-bottom: 1px solid #e4e7ea;
    @media only screen and (min-width: 960px)
    {
        display: grid;
        grid-gap: 20px;
        grid-template-areas:
                        "picture link"
                        "picture newTab"
                        "picture delete";
    }
}
.widget-logo__delete {
    grid-area: delete;
    height: fit-content;
}
.widget-logo__picture {
    grid-area: picture;
}
.widget-logo__link {
    grid-area: link;
}
.widget-logo__newTab {
    grid-area: newTab;
}
</style>
